import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { AdminLanguagesResponse } from '@utils/types/admin';

/**
 * Hook to fetch available languages and models
 *
 * GET /api/admin/on-prem/languages
 *
 * Returns list of available languages with model info
 */
export const useGetAdminLanguages = () => {
  const fetchLanguages = async () => {
    const url = `api/admin/on-prem/languages`;
    const response = await Axios.get<AdminLanguagesResponse>(url);
    return response.data;
  };

  return useQuery<AdminLanguagesResponse, AxiosError<BaseError>>(
    ['adminLanguages'],
    fetchLanguages,
    {
      useErrorBoundary: false,
      staleTime: 5 * 60 * 1000 // Consider stale after 5 minutes
    }
  );
};
